module.exports = __webpack_public_path__ + "static/media/LEYPARTS.426fec1e.png";